export default {
    "es": {
        "administrative_concepts": {
            "add": "Agregar concepto administrativo",
            "edit": "Editar concepto administrativo",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un concepto administrativo con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del concepto administrativo",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de concepto administrativo",
            "concept": "Concepto",
            "concept_placeholder": "Ingresa el concepto"
        },
        "administratives_dashboard": {
            "expenses": "Egreso",
            "income": "Ingresos",
            "invoiced": "Facturado",
            "invoiced_mayus": "FACTURADO",
            "invoiced_percentage": "Porcentaje facturado",
            "name": "Nombre",
            "payed": "PAGADO",
            "unbilled": "Por facturar",
            "utility": "Utilidad"
        },
        "auth": {
            "failed": "Estas credenciales no coinciden con nuestros registros.",
            "throttle": "Demasiados intentos de inicio de sesión. Por favor intente de nuevo en :seconds segundos."
        },
        "change_orders": {
            "add": "Agregar orden de cambio",
            "edit": "Editar orden de cambio",
            "delete": "Eliminar orden de cambio",
            "not_find": "No se puede encontrar una orden de cambio con este código.",
            "id": "Id",
            "type": "Tipo",
            "type_placeholder": "Ingresa el tipo de orden de cambio",
            "description": "Descripción",
            "description_placeholder": "Ingresa la descripción de la orden de cambio",
            "amount": "Monto",
            "amount_placeholder": "Ingresa el monto de la orden",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del orden de cambio",
            "status": "Estatus",
            "pdf": "PDF",
            "created_at": "Fecha de creación",
            "report_title": "Reporte de ordenes de cambio"
        },
        "concepts": {
            "add": "Agregar concepto",
            "edit": "Editar concepto",
            "delete": "Eliminar concepto",
            "not_find": "No se puede encontrar un concepto con este código.",
            "assigned_to_project": "Asignado a obra",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del concepto",
            "date": "Fecha",
            "date_placeholder": "Ingresa la fecha del concepto",
            "deposit": "Anticipo",
            "conceptable_type": "Tipo",
            "conceptable_type_placeholder": "Ingresa el tipo de concepto",
            "conceptable_id": "Administrativo\/Obra",
            "conceptable_id_placeholder": "Ingresa el administrativo u obra",
            "conceptable_name": "Administrativo\/Obra",
            "project": "Obra",
            "project_placeholder": "Ingresa la obra correspondiente",
            "administrative_concept": "Concepto Administrativo",
            "administrative_concept_placeholder": "Ingresa el concepto administrativo",
            "concept": "Concepto",
            "concept_placeholder": "Ingresa el concepto",
            "status": "Estatus",
            "status_placeholder": "Ingresa el estatus del concepto",
            "supplier": "Proveedor",
            "supplier_placeholder": "Ingresa el proveedor correspondiente",
            "payment": "Abono",
            "payment_placeholder": "Ingresa el abono",
            "charge": "Cargo",
            "charge_placeholder": "Ingresa el cargo",
            "project_mayus": "OBRA",
            "admin": "ADMINISTRATIVO",
            "supplier_mayus": "PROVEEDOR",
            "created_at": "Creado en",
            "report_title": "Reporte de Conceptos"
        },
        "customers": {
            "add": "Agregar cliente",
            "edit": "Editar cliente",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un cliente con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del cliente",
            "location": "Ubicación",
            "location_placeholder": "Ingresa ela ubicación del cliente",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de Customers"
        },
        "dashboard": {
            "active": "ACTIVO",
            "administrative": "ADMINISTRATIVO",
            "administratives": "Administrativos",
            "balance": "Balance",
            "concept": "Concepto",
            "created_at": "Creado en",
            "date": "Fecha",
            "difference": "Diferencia",
            "expenses": "Egreso",
            "finished": "FINALIZADO",
            "flows_balance": "Saldo",
            "income": "Ingresos",
            "in_account": "En cuenta",
            "invoiced": "FACTURADO",
            "new_project": "Nueva obra",
            "payable": "Por pagar",
            "payed": "PAGADO",
            "pending_expenses": "Gastos pendientes",
            "pending_income": "Ingresos pendientes",
            "project": "OBRA",
            "projects": "Obras",
            "receivable": "Por cobrar",
            "report_title": "Reporte de Flujos",
            "supplier": "PROVEEDOR",
            "suppliers": "PROVEEDORES"
        },
        "errors": {
            "fatal_error": "Se produjo un error fatal, póngase en contacto con nosotros.",
            "generic_error": "Ha ocurrido un error. Por favor intente de nuevo.",
            "unauthorized": "No autorizado.",
            "connection_error": "Error de conexión",
            "action_unauthorized": "No estas autorizado para realizar esta acción"
        },
        "feedback": {
            "rate": "¿Como te parece este sistema?",
            "comment": "¿Cuéntanos cómo ha sido tu experiencia?",
            "contact_me": "Controlla puede comunicarse conmigo en relación con mis comentarios."
        },
        "front": {
            "added_successfully": "Ha sido agregado con éxito.",
            "updated_successfully": "Ha sido actualizado con éxito.",
            "deleted_successfully": "Ha sido eliminado con éxito.",
            "imported_successfully": "Ha sido importado con éxito.",
            "delete_modal": "Eliminar",
            "delete_confirmation": "¿Seguro que quieres eliminar la {model} {attribute}?",
            "delete_confirmation2": "¿Seguro que quieres eliminar el {model} {attribute}?",
            "action_confirmation": "¿Seguro que deseas {action} esta {model}?",
            "action_confirmation2": "¿Seguro que deseas {action} este {model}?",
            "import_modal": "Importar :model desde un archivo CSV o Excel"
        },
        "login": {
            "email": "Correo electrónico",
            "password": "Contraseña",
            "keep_connected": "Recordarme",
            "forgot_password": "Restablecer",
            "login": "Iniciar sesión",
            "logout": "Cerrar sesión",
            "reset_password": "Restablecer la contraseña",
            "send_reset_link": "Enviar el enlace de reinicio",
            "password_confirmation": "Confirmación de contraseña",
            "still_having_trouble": "¿Sigues teniendo problemas para iniciar sesión?",
            "havent_account": "No tienes una cuenta?",
            "back_login": "Volver a Inicio de sesión",
            "register": "Crear cuenta",
            "welcome": "Bienvenido",
            "description": "Descripción"
        },
        "notifications": {
            "empty_title": "No hay notificaciones en este momento",
            "empty_msg": "Cuando tu equipo empiece a hacer cosas, mostraremos las notificaciones aquí.",
            "add_new_user": "Usuario Nuevo!",
            "add_new_user_message": "agrego un nuevo usuario"
        },
        "pagination": {
            "previous": "« Previous",
            "next": "Next »"
        },
        "passwords": {
            "password": "Las contraseñas deben tener al menos seis caracteres y coincidir con la confirmación.",
            "reset": "¡Tu contraseña ha sido restablecida!",
            "sent": "Hemos enviado por correo electrónico el enlace para restablecer su contraseña!",
            "token": "Este token de restablecimiento de contraseña no es válido.",
            "user": "No podemos encontrar un usuario con esa dirección de correo electrónico.",
            "cant_login": "¿No puedes iniciar sesión?",
            "very_weak": "Débil",
            "weak": "Normal",
            "good": "Buena",
            "strong": "Sólida",
            "very_strong": "Muy Sólida"
        },
        "projects": {
            "add": "Agregar obra",
            "edit": "Editar obra",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un obra con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre de la obra",
            "location": "Ubicación",
            "location_placeholder": "Ingresa ela ubicación de la obra",
            "country": "Pais",
            "country_placeholder": "Ingresa el pais de la obra",
            "customer": "Cliente",
            "customer_placeholder": "Ingresa el cliente de la obra",
            "customer_display": "Cliente",
            "finish_date": "Fecha de término",
            "price": "Precio antes de IVA",
            "purchase_order": "Orden de compras",
            "price_placeholder": "Ingresa el precio",
            "income": "Ingresos pagados",
            "invoiced_income": "Facturado",
            "iva": "IVA",
            "iva_placeholder": "Ingresa el IVA correspondiente",
            "total_price": "Precio total",
            "total_price_placeholder": "Ingresa el precio total",
            "status": "Estatus",
            "sale_cost": "Costo de venta",
            "sale_amount": "Precio total",
            "utility": "Utilidad",
            "unbilled": "Por facturar",
            "created_at": "Creado en",
            "report_title": "Reporte de obras"
        },
        "projects_dashboard": {
            "additive": "ADITIVA",
            "additives_total": "Total aditivas",
            "change_orders": "Ordenes de cambio",
            "deductible": "DEDUCTIVA",
            "deductibles_total": "Total deductivas",
            "download_pdf": "Descargar PDF",
            "expenses": "Egreso",
            "income": "Ingresos",
            "initial_amount": "Monto original",
            "invoiced": "Facturado",
            "invoiced_mayus": "FACTURADO",
            "invoiced_percentage": "Porcentaje facturado",
            "name": "Nombre",
            "payed": "PAGADO",
            "sale_amount": "Monto de venta",
            "unbilled": "Por facturar",
            "utility": "Utilidad"
        },
        "purchase_orders": {
            "add": "Agregar orden de compra",
            "edit": "Editar orden de compra",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un orden de compra con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre de la orden de compra",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de ordenes de compra"
        },
        "register": {
            "title": "Regístrate para obtener tu cuenta",
            "email": "Correo electrónico",
            "name": "Nombre de usuario",
            "password": "Contraseña",
            "register": "Crear cuenta",
            "message": "Al registrarte, confirmas que has leído y aceptado nuestros <a href=\"\/login\" class=\"content-vertical text-secondary\"> Términos de uso<\/a> y nuestra <a href=\"\/login\"> Política de privacidad<\/a>.",
            "back_login": "¿Ya tienes una cuenta de Controlla? Iniciar sesión",
            "very_weak": "Débil",
            "weak": "Normal",
            "good": "Buena",
            "strong": "Sólida",
            "very_strong": "Muy Sólida"
        },
        "reset": {
            "subject": "Restablece tu contraseña de Controlla",
            "line_1": "Recibió este correo electrónico porque recibimos una solicitud de restablecimiento de contraseña para su cuenta.",
            "action": "Restablecer contraseña",
            "line_2": "Este enlace de restablecimiento de contraseña caducará en :count minutos.",
            "line_3": "Si no solicitó un restablecimiento de contraseña, no se requiere ninguna otra acción."
        },
        "strings": {
            "administrative_concepts": "Administrativos",
            "administrative_summary": "Administrativo general",
            "administrative_concept": "Concepto administrativo",
            "add_pdf": "Añadir PDF",
            "assign_to": "Añadir a Obra",
            "balance_sheet": "Balance general",
            "change_status": "Cambiar status",
            "concept": "Concepto",
            "concepts": "Conceptos",
            "dashboard": "Inicio",
            "flows": "Flujos",
            "overview": "Inicio",
            "users": "Usuarios",
            "user": "Usuario",
            "change_order": "Orden de cambio",
            "change_orders": "Ordenes de cambio",
            "customer": "Cliente",
            "customers": "Clientes",
            "quotation": "Cotización",
            "quotations": "Cotizaciones",
            "quotation_detail": "Quotation Detail",
            "quotation_details": "Quotation Details",
            "purchase_order": "Orden de Compra",
            "oc_number": "# O.C.",
            "purchase_orders": "Ordenes de Compra",
            "sale": "Venta",
            "sales": "Ventas",
            "supplier": "Proveedor",
            "suppliers": "Proveedores",
            "supplier_reception": "Recepción de proveedores",
            "pending_expenses": "Gastos pendientes",
            "pending_income": "Ingresos pendientes",
            "product": "Producto",
            "products": "Productos",
            "project": "Obra",
            "projects": "Obras",
            "provider": "Proveedor",
            "providers": "Proveedores",
            "mining_group": "Grupo Minero",
            "mining_groups": "Grupos Mineros",
            "summary": "General",
            "project_summary": "Obra General",
            "project_flow": "Flujo de obra",
            "description": "Un resumen de sus {attribute}",
            "search": "Buscar {attribute} por {columns} ó {column}",
            "filters": "Filtros",
            "clear": "Limpiar",
            "apply": "Aplicar",
            "select_date": "Selecciona una fecha",
            "multiple": "Selección multiple",
            "display_list": "Ver en lista",
            "display_grid": "Ver en grid (deshabilitado)",
            "print": "Imprimir",
            "delete": "Eliminar",
            "add": "Agregar",
            "addDetail": "Agregar Detalle",
            "edit": "Editar",
            "save": "Guardar",
            "accept": "Aceptar",
            "cancel": "Cancelar",
            "view": "Ver",
            "import": "Importar",
            "export": "Exportar",
            "registered_on": "Registrado desde",
            "order_by": "Ordenado por",
            "options": "Más opciones",
            "notifications": "Notificaciones",
            "messages": "Mensajes",
            "no_notifications": "No tienes notificaciones",
            "no_messages": "No tienes mensajes",
            "see_all": "Marcar todo como leído",
            "exit": "Salir",
            "feedback": "Enviar Comentarios",
            "give_feedback": "Dar opinión",
            "shortcuts": "Atajos de teclado",
            "close_modal": "Cerrar modal",
            "create": "Crear registro",
            "view_selected": "Ver seleccionado",
            "edit_selected": "Editar seleccionado",
            "view_notifications": "Ver notificaciones",
            "find": "Buscar un registro",
            "register": "Registro",
            "cancelled": "Cancelado",
            "sold": "Vendido",
            "invoiced": "Facturado",
            "paid": "Pagado",
            "pending": "Pendiente",
            "approved": "Aprobado",
            "received": "Recibido",
            "send": "Enviado",
            "status": "Estatus",
            "status_placeholder": "Ingrese el estatus",
            "action_sold": "Pagar",
            "action_invoiced": "Facturar",
            "action_paid": "Pagar",
            "action_approved": "Aprobar",
            "action_received": "Recibir",
            "action_send": "Enviar",
            "action_active": "Activar",
            "action_inactive": "Inactivar",
            "download_purchase_order": "Descargar Orden de compra"
        },
        "suppliers": {
            "add": "Agregar proveedor",
            "edit": "Editar proveedor",
            "delete": "Eliminar proveedor",
            "not_find": "No se puede encontrar un proveedor con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del proveedor",
            "location": "Ubicación",
            "location_placeholder": "Ingresa la ubicació del proveedor",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de Suppliers",
            "total_available_balance": "Saldo total disponible",
            "total_investment": "Inversion total"
        },
        "suppliers_dashboard": {
            "advance_payment": "Anticipos",
            "add_deposit": "Añadir anticipo",
            "amount": "Monto",
            "amount_placeholder": "ingrese el monto correspondiente",
            "assign_to": "Asignar a",
            "available_balance": "Saldo disponible",
            "date": "Fecha",
            "description": "Descripción",
            "invoiced_mayus": "FACTURADO",
            "name": "Nombre",
            "project": "Obra",
            "project_placeholder": "Ingrese el nombre de la Obra",
            "payed_mayus": "PAGADO",
            "total_investment": "Inversion total"
        },
        "users": {
            "add": "Agregar usuario",
            "edit": "Editar usuario",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un usuario con este código.",
            "actived_error": "Usuario ya activo",
            "inactived_error": "Usuario ya inactivo",
            "actived": "El usuario se ha activado",
            "inactived": "El usuario se ha inactivado",
            "active": "Activo",
            "inactive": "Inactivo",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del usuario",
            "email": "Correo",
            "email_placeholder": "Ingresa el correo electrónico del usuario",
            "password": "Contraseña",
            "password_placeholder": "Ingresa la contraseña del usuario",
            "confirm_password": "Confirma Contraseña",
            "confirm_password_placeholder": "Confirma la contraseña del usuario",
            "role": "Rol",
            "role_placeholder": "Ingresa el rol del usuario",
            "status": "Estatus",
            "leave_empty": "Dejar vacío para mantener la contraseña actual.",
            "created_at": "Creado en",
            "report_title": "Reporte de Usuarios",
            "Admin": "Administrador",
            "Viewer": "Espectador"
        },
        "validation": {
            "accepted": "El campo {attribute} debe ser aceptado.",
            "active_url": "El campo {attribute} no es una URL válida.",
            "after": "El campo {attribute} debe ser una fecha después a :date.",
            "after_or_equal": "El campo {attribute} debe ser una fecha posterior o igual a :date.",
            "alpha": "El campo {attribute} solo puede contener letras.",
            "alpha_dash": "El campo {attribute} solo puede contener letras, números, guiones y guiones bajos.",
            "alpha_num": "El campo {attribute} solo puede contener letras y números.",
            "array": "El campo {attribute} debe ser una matriz.",
            "before": "El campo {attribute} debe ser una fecha antes de :date.",
            "before_or_equal": "El campo {attribute} debe ser una fecha antes o igual a :date.",
            "between": {
                "numeric": "El {attribute} debe estar entre {min} y {max}.",
                "file": "El {attribute} debe estar entre {min} y {max} kilobytes.",
                "string": "El {attribute} debe estar entre {min} y {max} caracteres.",
                "array": "El {attribute} debe estar entre {min} y {max} artículos."
            },
            "boolean": "El campo {attribute} debe ser verdadero o falso.",
            "confirmed": "El {attribute} la confirmación no coincide.",
            "date": "La {attribute} no es una fecha valida.",
            "date_format": "La {attribute} no coincide con el formato {format}.",
            "different": "El {attribute} y {other} deben ser diferentes.",
            "digits": "El {attribute} deben ser {digits} dígitos.",
            "digits_between": "El {attribute} debe estar entre {min} y {max} dígitos.",
            "dimensions": "El {attribute} tiene dimensiones de imagen inválidas.",
            "distinct": "El {attribute} campo tiene un valor duplicado.",
            "email": "El campo {attribute} debe ser una dirección de correo electrónico válida.",
            "exists": "El seleccionado {attribute} no es válido.",
            "file": "El {attribute} debe ser un archivo.",
            "filled": "El {attribute} campo debe tener un valor.",
            "gt": {
                "numeric": "El {attribute} debe ser mayor que :value.",
                "file": "El {attribute} debe ser mayor que :value kilobytes.",
                "string": "El {attribute} debe ser mayor que :value caracteres.",
                "array": "El {attribute} debe tener más que :value artículos."
            },
            "gte": {
                "numeric": "El {attribute} debe ser mayor o igual que :value.",
                "file": "El {attribute} debe ser mayor o igual que :value kilobytes.",
                "string": "El {attribute} debe ser mayor o igual que :value caracteres.",
                "array": "El {attribute} debe tener :value artículos o más."
            },
            "image": "La {attribute} debe ser una imagen.",
            "in": "El seleccionado {attribute} no es válido.",
            "in_array": "El {attribute} campo no existe en {other}.",
            "integer": "El {attribute} debe ser un entero.",
            "ip": "La {attribute} debe ser una dirección IP válida.",
            "ipv4": "La {attribute} debe ser una dirección IPv4 válida.",
            "ipv6": "La {attribute} debe ser una dirección IPv6 válida.",
            "json": "La {attribute} debe ser una cadena JSON válida.",
            "lt": {
                "numeric": "El {attribute} debe ser menor que :value.",
                "file": "El {attribute} debe ser menor que :value kilobytes.",
                "string": "El {attribute} debe ser menor que :value caracteres.",
                "array": "El {attribute} debe tener menos que :value artículos."
            },
            "lte": {
                "numeric": "El {attribute} debe ser menor o igual :value.",
                "file": "El {attribute} debe ser menor o igual :value kilobytes.",
                "string": "El {attribute} debe ser menor o igual :value caracteres.",
                "array": "El {attribute} no debe tener más de :value artículos."
            },
            "max": {
                "numeric": "El {attribute} no puede ser mayor que {max}.",
                "file": "El {attribute} no puede ser mayor que {max} kilobytes.",
                "string": "El {attribute} no puede ser mayor que {max} caracteres.",
                "array": "El {attribute} no puede tener más de {max} artículos."
            },
            "mimes": "El {attribute} must be a file of type: :values.",
            "mimetypes": "Los {attribute} must be a file of type: :values.",
            "min": {
                "numeric": "El campo {attribute} debe ser al menos de {min}.",
                "file": "El campo {attribute} debe ser al menos de {min} kilobytes.",
                "string": "El campo {attribute} debe ser al menos de {min} caracteres.",
                "array": "El campo {attribute} debe tener al menos {min} artículos."
            },
            "not_in": "El seleccionado {attribute} no es válido.",
            "not_regex": "El {attribute} formato no es válido.",
            "numeric": "El campo {attribute} tiene que ser un número.",
            "present": "El campo {attribute} debe estar presente.",
            "regex": "El campo {attribute} formato no es válido.",
            "required": "El campo {attribute} es requerido.",
            "required_if": "El campo {attribute} es requerido cuando {other} es :value.",
            "required_unless": "El campo {attribute} es requerido a menos que {other} es en :values.",
            "required_with": "El campo {attribute} es requerido cuando :values esta presente.",
            "required_with_all": "El campo {attribute} es requerido cuando :values esta presente.",
            "required_without": "El campo {attribute} es requerido cuando :values no esta presente.",
            "required_without_all": "El campo {attribute} es requerido cuando ninguno de :values estan presentes.",
            "same": "El campo {attribute} debe coincidir con {other}.",
            "size": {
                "numeric": "El {attribute} debe ser :size.",
                "file": "El {attribute} debe ser :size kilobytes.",
                "string": "El {attribute} debe ser :size caracteres.",
                "array": "El {attribute} debe contener :size artículos."
            },
            "string": "El {attribute} debe ser un texto.",
            "timezone": "El {attribute} debe ser una zona válida.",
            "unique": "El {attribute} ya se ha tomado.",
            "uploaded": "El {attribute} no se pudo cargar.",
            "url": "El {attribute} formato no válido.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "verification": {
            "title": "Verifica tu correo electrónico",
            "check_email": "Necesitamos verificar tu dirección de email",
            "check_email_label": "Consulta el correo electrónico para finalizar el registro. Te hemos enviado un enlace de registro a la dirección:",
            "resend_email": "¿No has recibido el enlace de registro? Volver a enviarlo",
            "resend_succesfully": "Reenviado satisfactoriamente",
            "reset_email": "Cambiar dirección de correo electrónico"
        },
        "welcome": {
            "subject": "Bienvenido a Controlla",
            "line_1": "Bienvenido.",
            "action": "Pruébalo ahora"
        }
    },
    "en": {
        "administrative_concepts": {
            "add": "Add administrative concept",
            "edit": "Edit administrative concept",
            "delete": "Delete administrative concept",
            "not_find": "Can not find administrative concept with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the administrative concept's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "Administrative concepts Report"
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "password": "The provided password is incorrect.",
            "throttle": "Too many login attempts. Please try again in :seconds seconds."
        },
        "change_orders": {
            "add": "Add change order",
            "edit": "Edit change order",
            "delete": "Delete changeOrder",
            "not_find": "Can not find changeOrder with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the changeOrder's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "ChangeOrders Report",
            "type": "Type",
            "description": "Description",
            "amount": "Amount",
            "pdf": "PDF",
            "type_placeholder": "Insert the change order's type",
            "description_placeholder": "Insert the change order's description",
            "amount_placeholder": "Insert the change orders's amount"
        },
        "concepts": {
            "add": "Add concept",
            "edit": "Edit concept",
            "delete": "Delete concept",
            "not_find": "Can not find concept with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the concept's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "Concepts Report",
            "date": "Date",
            "conceptable_type": "Type",
            "conceptable_name": "Project",
            "concept": "Concept",
            "payment": "Payment",
            "charge": "Charge",
            "deposit": "Deposit",
            "assigned_to_project": "Assigned to project",
            "supplier_mayus": "SUPPLIER",
            "admin": "ADMINISTRADOR",
            "project_mayus": "PROJECT",
            "conceptable_type_placeholder": "Insert the concept's type",
            "status_placeholder": "Insert the status' concept",
            "concept_placeholder": "Insert the concept",
            "administrative_concept": "Administrative",
            "administrative_concept_placeholder": "Insert the administrative concept",
            "project": "Project",
            "project_placeholder": "Insert the project",
            "supplier": "Supplier",
            "supplier_placeholder": "Insert the supplier"
        },
        "customers": {
            "add": "Add customer",
            "edit": "Edit customer",
            "delete": "Delete customer",
            "not_find": "Can not find customer with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the customer's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "Customers Report",
            "location": "Location"
        },
        "errors": {
            "fatal_error": "A fatal error occurred, please contact us.",
            "generic_error": "An error occurred, please try again.",
            "unauthorized": "Unauthorized.",
            "forbidden": "Forbidden.",
            "connection_error": "Connection error",
            "action_unauthorized": "This action is unauthorized."
        },
        "feedback": {
            "rate": "What do you think of this experience?",
            "comment": "Tell us how was your experience?",
            "contact_me": "Controlla can contact me about my feedback."
        },
        "front": {
            "added_successfully": "It has been added successfully.",
            "updated_successfully": "It has been updated successfully.",
            "deleted_successfully": "It has been deleted successfully.",
            "imported_successfully": "It has been imported successfully.",
            "delete_modal": "Delete",
            "delete_confirmation": "Are you sure you want to delete the {model} {attribute}?",
            "delete_confirmation2": "Are you sure you want to delete {model} {attribute}?",
            "action_confirmation": "Are you sure you want to {action} this {model}?",
            "action_confirmation2": "Are you sure you want to {action} this {model}?",
            "import_modal": "Import {model} from CSV or Excel file"
        },
        "login": {
            "email": "Email",
            "password": "Password",
            "keep_connected": "Keep connected",
            "forgot_password": "Forgot password",
            "login": "Login",
            "logout": "Logout",
            "reset_password": "Reset password",
            "send_reset_link": "Send the reset link",
            "password_confirmation": "Password confirmation",
            "still_having_trouble": "Still having trouble logging in?",
            "havent_account": "Don't have a account?",
            "back_login": "Back to login",
            "register": "Create account",
            "welcome": "Welcome",
            "description": "Description app"
        },
        "notifications": {
            "empty_title": "No notifications at this time",
            "empty_msg": "When your team starts doing things, we will show the notifications here.",
            "add_new_user": "New User!",
            "add_new_user_message": "has added a new user"
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have emailed your password reset link!",
            "throttled": "Please wait before retrying.",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that email address.",
            "very_weak": "Very weak",
            "weak": "Weak",
            "good": "Good",
            "strong": "Strong",
            "very_strong": "Very strong"
        },
        "projects": {
            "add": "Add project",
            "edit": "Edit project",
            "delete": "Delete project",
            "not_find": "Can not find project with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the project's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "Projects Report",
            "finish_date": "Finish Date",
            "customer_display": "Customer",
            "price": "Price before taxes",
            "iva": "Tax",
            "sale_amount": "Sale Amount",
            "sale_cost": "Sale Cost",
            "utility": "Utility",
            "income": "Income",
            "invoiced_income": "Invoiced Income",
            "unbilled": "Unbilled",
            "purchase_order": "Purchase Order",
            "customer": "Customer",
            "customer_placeholder": "Insert the project's customer",
            "location": "Ubicación",
            "location_placeholder": "Insert the project's location",
            "country": "Pais",
            "country_placeholder": "Inser the project's country",
            "price_placeholder": "Insert the price",
            "iva_placeholder": "Insert the TAX",
            "total_price": "Total price"
        },
        "register": {
            "title": "Sign up to get your account",
            "email": "Email",
            "name": "Username",
            "password": "Password",
            "register": "Create account",
            "message": "By registering, confirm that you have read and accepted our  <a href=\"\/login\"> Terms of use <\/a> and our <a href=\"\/login\"> Privacy policy <\/a>.",
            "back_login": "Already have an Controlla account? Log in",
            "very_weak": "Very weak",
            "weak": "Weak",
            "good": "Good",
            "strong": "Strong",
            "very_strong": "Very strong"
        },
        "reset": {
            "subject": "Reset your Controlla Password",
            "line_1": "You are receiving this email because we received a password reset request for your account.",
            "action": "Reset Password",
            "line_2": "This password reset link will expire in :count minutes.",
            "line_3": "If you did not request a password reset, no further action is required."
        },
        "strings": {
            "dashboard": "Dashboard",
            "overview": "Overview",
            "user": "User",
            "users": "Users",
            "customer": "Customer",
            "customers": "Customers",
            "quotation": "Quotation",
            "quotations": "Quotations",
            "quotation_detail": "Quotation Detail",
            "quotation_details": "Quotation Details",
            "purchase_order": "Purchase Order",
            "purchase_orders": "Purchase Orders",
            "description": "An Overview of your {attribute}",
            "search": "Search {attribute} by {columns} or {column}",
            "filters": "Filters",
            "clear": "Clear",
            "apply": "Apply",
            "select_date": "Select a date",
            "multiple": "Multiple",
            "display_list": "Display list",
            "display_grid": "Display grid (enabled)",
            "print": "Print",
            "delete": "Delete",
            "add": "Add",
            "addDetail": "Add Detail",
            "edit": "Edit",
            "save": "Save",
            "accept": "Accept",
            "cancel": "Cancel",
            "view": "View",
            "import": "Import",
            "export": "Export",
            "registered_on": "Registered on",
            "order_by": "Order by",
            "options": "More options",
            "notifications": "Notifications",
            "messages": "Messages",
            "no_notifications": "No notifications",
            "no_messages": "No messages",
            "see_all": "See all",
            "exit": "Exit",
            "feedback": "Feedback",
            "give_feedback": "Give feedback",
            "shortcuts": "Shortcuts",
            "close_modal": "Close modal",
            "create": "Create resource",
            "view_selected": "View selected",
            "edit_selected": "Edit selected",
            "view_notifications": "View notifications",
            "find": "find",
            "register": "Register",
            "cancelled": "Cancelled",
            "sold": "Sold",
            "invoiced": "Invoiced",
            "paid": "Paid",
            "pending": "Pending",
            "approved": "Approved",
            "received": "Received",
            "send": "Sent",
            "action_sold": "Sell",
            "action_invoiced": "Invoice",
            "action_paid": "Pay",
            "action_approved": "Approved",
            "action_received": "Received",
            "action_send": "Send",
            "action_active": "Active",
            "action_inactive": "Inactive",
            "flows": "Flows",
            "balance_sheet": "Balance sheet",
            "pending_expenses": "Pending Expenses",
            "pending_income": "Pending Income",
            "concept": "Concept",
            "concepts": "Concepts",
            "administrative_concept": "Administrative",
            "administrative_concepts": "Administratives",
            "projects": "Projects",
            "administrative_summary": "Administrative summary",
            "summary": "Summary",
            "project_summary": "Porject summary",
            "project_flow": "Project flow",
            "supplier_reception": "Supplier reception",
            "change_order": "Change order",
            "change_status": "Change status",
            "status": "Status",
            "project": "Project"
        },
        "suppliers": {
            "add": "Add supplier",
            "edit": "Edit supplier",
            "delete": "Delete supplier",
            "not_find": "Can not find supplier with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the supplier's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "Suppliers Report",
            "total_available_balance": "Total available balance",
            "total_investment": "Total investment",
            "location": "Location"
        },
        "users": {
            "add": "Add user",
            "edit": "Edit user",
            "delete": "Delete user",
            "not_find": "Can not find user with this code.",
            "actived_error": "User is already active",
            "inactived_error": "User is already inactive",
            "actived": "User has been activated",
            "inactived": "User has been inactivated",
            "active": "Active",
            "inactive": "Inactive",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the user's name",
            "email": "Email",
            "email_placeholder": "Enter the user's email",
            "password": "Password",
            "password_placeholder": "Enter the user's password",
            "confirm_password": "Confirm Password",
            "confirm_password_placeholder": "Enter the user's confirm password",
            "role": "Role",
            "role_placeholder": "Enter the user's role",
            "status": "Status",
            "leave_empty": "Leave empty to keep the current password",
            "created_at": "Created at",
            "report_title": "Users Report",
            "Admin": "Administrador",
            "Viewer": "Viewer"
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "accepted_if": "The {attribute} must be accepted when :other is :value.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} must only contain letters.",
            "alpha_dash": "The {attribute} must only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} must only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "current_password": "The password is incorrect.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "declined": "The {attribute} must be declined.",
            "declined_if": "The {attribute} must be declined when :other is :value.",
            "different": "The {attribute} and :other must be different.",
            "digits": "The {attribute} must be :digits digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "ends_with": "The {attribute} must end with one of the following: :values.",
            "enum": "The selected {attribute} is invalid.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than :value.",
                "file": "The {attribute} must be greater than :value kilobytes.",
                "string": "The {attribute} must be greater than :value characters.",
                "array": "The {attribute} must have more than :value items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal to :value.",
                "file": "The {attribute} must be greater than or equal to :value kilobytes.",
                "string": "The {attribute} must be greater than or equal to :value characters.",
                "array": "The {attribute} must have :value items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in :other.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than :value.",
                "file": "The {attribute} must be less than :value kilobytes.",
                "string": "The {attribute} must be less than :value characters.",
                "array": "The {attribute} must have less than :value items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal to :value.",
                "file": "The {attribute} must be less than or equal to :value kilobytes.",
                "string": "The {attribute} must be less than or equal to :value characters.",
                "array": "The {attribute} must not have more than :value items."
            },
            "mac_address": "The {attribute} must be a valid MAC address.",
            "max": {
                "numeric": "The {attribute} must not be greater than {max}.",
                "file": "The {attribute} must not be greater than {max} kilobytes.",
                "string": "The {attribute} must not be greater than {max} characters.",
                "array": "The {attribute} must not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: :values.",
            "mimetypes": "The {attribute} must be a file of type: :values.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "multiple_of": "The {attribute} must be a multiple of :value.",
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "password": "The password is incorrect.",
            "present": "The {attribute} field must be present.",
            "prohibited": "The {attribute} field is prohibited.",
            "prohibited_if": "The {attribute} field is prohibited when :other is :value.",
            "prohibited_unless": "The {attribute} field is prohibited unless :other is in :values.",
            "prohibits": "The {attribute} field prohibits :other from being present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_array_keys": "The {attribute} field must contain entries for: :values.",
            "required_if": "The {attribute} field is required when :other is :value.",
            "required_unless": "The {attribute} field is required unless :other is in :values.",
            "required_with": "The {attribute} field is required when :values is present.",
            "required_with_all": "The {attribute} field is required when :values are present.",
            "required_without": "The {attribute} field is required when :values is not present.",
            "required_without_all": "The {attribute} field is required when none of :values are present.",
            "same": "The {attribute} and :other must match.",
            "size": {
                "numeric": "The {attribute} must be :size.",
                "file": "The {attribute} must be :size kilobytes.",
                "string": "The {attribute} must be :size characters.",
                "array": "The {attribute} must contain :size items."
            },
            "starts_with": "The {attribute} must start with one of the following: :values.",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid timezone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} must be a valid URL.",
            "uuid": "The {attribute} must be a valid UUID.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "verification": {
            "title": "Verify your Email Address",
            "check_email": "Check the inbox to finish the registration.",
            "check_email_label": "Check the email to finish the registration. We have sent you a registration link to the address:",
            "resend_email": "You have not received the registration link? Resend",
            "resend_succesfully": "Successfully resend",
            "reset_email": "Change email address"
        },
        "welcome": {
            "subject": "Welcome to Controlla",
            "line_1": "Welcome to controlla.",
            "action": "Start now"
        }
    }
};